var DataWarehouseIds;
(function (DataWarehouseIds) {
    DataWarehouseIds["Perks"] = "2";
    DataWarehouseIds["Recognition"] = "18";
    DataWarehouseIds["Insights"] = "28";
})(DataWarehouseIds || (DataWarehouseIds = {}));
export default DataWarehouseIds;
